(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mgr-aval-real-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
const button=event.target.closest('[data-aval-step]');
if(!button)return;
const track=document.getElementById(button.getAttribute('aria-controls'));
if(!track)return;
const item=track.querySelector('.mgr-aval-gallery__item');
const gap=parseFloat(getComputedStyle(track).gap)||0;
track.scrollBy({left:Number(button.dataset.avalStep)*((item?item.getBoundingClientRect().width:track.clientWidth)+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
});

  } catch(e) { console.error(e); }
})();
})();
